import React from "react";
import { forwardRef } from "react";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Box } from "@mui/material";
import 'dayjs/locale/en-in';

const DateFilter = forwardRef(function ({ label }, ref ) {
	return (
		<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-in">
			<Box
				sx={{
					width: '100%',
					height: '100%',
					display: 'flex',
					justifyContent: 'center',
					position: 'relative',
				}}
			>
				<DatePicker
					label={label}
					disableFuture
					inputRef={ref}
					format="DD/MM/YYYY"
					slotProps={{
						field: { clearable: true },
						textField: {
						  sx: {
							width: '100%',
							margin: '5px'
						  }
						},
						actionBar: ({ wrapperVariant }) => ({
							actions: wrapperVariant === 'desktop' ? [] : ['cancel', 'accept', 'clear'],
						}),
					}}
					
				/>
			</Box>
		</LocalizationProvider>
	)
});

export default DateFilter;